export default __webpack_public_path__ + "static/media/logo.e5d4a9f0.svg";